import { combineReducers } from 'redux'
import FlyReducer from './common/reducer'

const reducer = combineReducers({
  common: FlyReducer
})

export default reducer
